import { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Button, message, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { jwtDecode } from 'jwt-decode';

import { getServiceUrl } from '../../config';
import { getS3Details } from '../../utility';
import { API_FILE_PROCESS } from '../../utility';

const API_BASE_URL = getServiceUrl();

const UploadEHR = (props) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const { patientguid } = useParams();

  const token = localStorage.getItem('tokenId');
  const decoded = jwtDecode(token);

  const fileDetailsForDB = async () => {
    // Upload PDF files to S3 and prepare file details.
    const uploadRequests = fileList
      .filter((file) => file.type === 'application/pdf')
      .map((file) => {
        const baseName = file.name.split('.')[0];
        const newName = `${baseName}_${Date.now()}.pdf`;
        const newFile = new File([file], newName, { type: file.type });
        const S3 = getS3Details();
        return S3.upload({
          Bucket: 'rgenx',
          Key: `EHR/${decoded.userGuid}/${patientguid}/${newName}`,
          Body: newFile,
          ContentType: file.type,
        })
          .promise()
          .then((uploadResponse) => ({
            fileName: newName,
            fileUrl: uploadResponse.Location,
          }));
      });

    const uploadResults = await Promise.all(uploadRequests);
    const fileDetails = uploadResults.map((file) => ({
      filename: file.fileName,
      fileurl: file.fileUrl,
    }));
    return fileDetails;
  };

  const handleUpload = async () => {
    setUploading(true);
    // Prepare file details for DB after S3 upload.
    const fileDetails = await fileDetailsForDB();
    try {
      // Save file details in the backend.
      await axios.post(
        API_BASE_URL + 'doctors/insertmedicalfile',
        { filedetails: fileDetails },
        {
          headers: {
            rdxtoken: localStorage.getItem('tokenId'),
            patientguid,
          },
        },
      );

      // Fire-and-forget backend process calls.
      fileDetails.forEach((file) => {
        const payload = {
          s3_uri: `s3://rgenx/EHR/${decoded.userGuid}/${patientguid}/${file.filename}`,
          file_id: file.filename,
          patient_guid: patientguid,
        };
        axios
          .post(`${API_FILE_PROCESS}/process_pdf`, payload)
          .catch((err) =>
            console.error('Error starting backend process!', err),
          );
      });
      setFileList([]);
      message.success('Upload successful! Backend processing started.');
      props.setCurrStep((prevStep) => prevStep + 1);
    } catch (error) {
      console.error('Error uploading file!', error);
      message.error('File Upload failed!');
    } finally {
      setUploading(false);
    }
  };

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  return (
    <div className="m-auto w-2/3">
      <Upload.Dragger {...uploadProps}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single or bulk upload. Strictly prohibited from
          uploading company data or other banned files.
        </p>
      </Upload.Dragger>
      <Button
        type="primary"
        onClick={handleUpload}
        disabled={fileList.length === 0}
        loading={uploading}
        className="my-3 w-full p-3"
      >
        {uploading ? 'Uploading' : 'Start Upload'}
      </Button>
    </div>
  );
};

export default UploadEHR;
